@if (hasData && hasBusinessUnits && (!!value || showFieldAsEdit)) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    @if (showFieldAsEdit) {
      <div>
        <div
          class="business-units"
          [ngClass]="{ 'disabled': !(businessUnits?.length > 0) }">
          <topo-business-unit-select
            [multiSelectionMode]="true"
            [selectedUIds]="selectedUIds"
            [businessUnits]="businessUnits"
            [flowMode]="true"
            location="right"
          (selectedChanged)="onBusinessUnitsSelectionChanged($event)"></topo-business-unit-select>
        </div>
      </div>
    } @else {
      <div class="is-readonly">
        @if (selectedUIds?.length > 0) {
          <div>
            <topo-business-unit-select
              [multiSelectionMode]="true"
              [selectedUIds]="selectedUIds"
              [businessUnits]="businessUnits"
              [flowMode]="true"
            [readonly]="true"></topo-business-unit-select>
          </div>
        }
        @if (!(selectedUIds?.length > 0)) {
          <div>---</div>
        }
      </div>
    }
  </div>
}
